import { Grid } from '@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const BorrarConexionesFilters = ({
    filters,
    handleSearch,
    handleChangeFilters,
    disableFilters,
    clearFilters
}) => {

    return (
        <Grid
            container
            spacing={2}
            sx={{ marginBottom: '25px' }}
        >
            <Grid size={{ xs: 12, md: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'int',
                        displayName: 'HC',
                        name: 'idPaciente',
                        key: `${filters?.idPaciente}-idPaciente`,
                        disabled: disableFilters
                    }}
                    value={filters.idPaciente || ''}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2, xl: 2 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'int',
                        displayName: 'Contrato',
                        name: 'idContrato',
                        key: `${filters?.idContrato}-idContrato`,
                        disabled: disableFilters
                    }}
                    value={filters.idContrato || ''}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'date',
                        displayName: 'Fecha desde',
                        name: 'fechaDesde',
                        key: `${filters?.fechaDesde}-fechaDesde`,
                        disabled: disableFilters
                    }}
                    value={filters.fechaDesde}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid size={{ xs: 12, md: 2.5, xl: 2.5 }}>
                <RenderInputByTypeMobile
                    input={{
                        type: 'date',
                        displayName: 'Fecha hasta',
                        name: 'fechaHasta',
                        key: `${filters?.fechaHasta}-fechaHasta`,
                        disabled: disableFilters
                    }}
                    value={filters.fechaHasta}
                    handleChange={handleChangeFilters}
                />
            </Grid>
            <Grid sx={{ textAlign: 'center' }} size={{ xs: 12, md: 2, xl: 2 }}>
                <CustomButton
                    variant='outlined'
                    onClick={clearFilters}
                    size='small'
                >
                    Reiniciar filtros
                </CustomButton>
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, md: 1, xl: 1 }}>
                <CustomButton
                    variant='contained'
                    onClick={() => handleSearch()}
                    size='small'
                    disabled={disableFilters}
                >
                    Buscar
                </CustomButton>
            </Grid>
        </Grid>
    )
}